"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import type { ApiXTdhTokensPage } from "@/generated/models/ApiXTdhTokensPage";
import { useTokenMetadataQuery } from "@/hooks/useAlchemyNftQueries";
import type { TokenMetadata } from "@/types/nft";
type TokenMetadataMap = Map<string, TokenMetadata>;
interface UseXtdhTokenMetadataMapResult {
  readonly metadataMap: TokenMetadataMap;
  readonly isFetching: boolean;
  readonly hasError: boolean;
}
export function useXtdhTokenMetadataMap(contractAddress, tokens) {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Map();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [metadataMap, setMetadataMap] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMetadataMap(new Map());
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== contractAddress) {
    t2 = [contractAddress];
    $[2] = contractAddress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  bb0: {
    if (!tokens.length) {
      let t4;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      t3 = t4 as string[];
      break bb0;
    }
    let t4;
    if ($[5] !== tokens) {
      t4 = tokens.map(_temp).filter(_temp2).map(_temp3);
      $[5] = tokens;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = t4;
  }
  const tokenIds = t3;
  let t4;
  bb1: {
    if (!tokenIds.length) {
      let t5;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      t4 = t5;
      break bb1;
    }
    let missing;
    if ($[8] !== metadataMap || $[9] !== tokenIds) {
      missing = [];
      for (const tokenId_1 of tokenIds) {
        if (!metadataMap.has(tokenId_1)) {
          missing.push(tokenId_1);
        }
      }
      $[8] = metadataMap;
      $[9] = tokenIds;
      $[10] = missing;
    } else {
      missing = $[10];
    }
    t4 = missing;
  }
  const missingTokenIds = t4;
  const t5 = contractAddress ?? undefined;
  const t6 = Boolean(contractAddress && missingTokenIds.length > 0);
  let t7;
  if ($[11] !== missingTokenIds || $[12] !== t5 || $[13] !== t6) {
    t7 = {
      address: t5,
      tokenIds: missingTokenIds,
      enabled: t6
    };
    $[11] = missingTokenIds;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const metadataQuery = useTokenMetadataQuery(t7);
  let t8;
  let t9;
  if ($[15] !== metadataQuery.data) {
    t8 = () => {
      const entries = metadataQuery.data;
      if (!entries || entries.length === 0) {
        return;
      }
      setMetadataMap(previous => {
        const next = new Map(previous);
        for (const entry of entries) {
          const decimalKey = entry.tokenId.toString(10);
          next.set(decimalKey, entry);
          if (entry.tokenIdRaw) {
            next.set(entry.tokenIdRaw, entry);
            next.set(entry.tokenIdRaw.toLowerCase(), entry);
          }
        }
        return next;
      });
    };
    t9 = [metadataQuery.data];
    $[15] = metadataQuery.data;
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  useEffect(t8, t9);
  let t10;
  if ($[18] !== metadataMap || $[19] !== metadataQuery.isError || $[20] !== metadataQuery.isFetching) {
    t10 = {
      metadataMap,
      isFetching: metadataQuery.isFetching,
      hasError: metadataQuery.isError
    };
    $[18] = metadataMap;
    $[19] = metadataQuery.isError;
    $[20] = metadataQuery.isFetching;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp3(tokenId_0) {
  return Math.trunc(tokenId_0).toString();
}
function _temp2(tokenId) {
  return typeof tokenId === "number" && Number.isFinite(tokenId);
}
function _temp(token) {
  return token.token;
}